import { render, staticRenderFns } from "./TheEditor.vue?vue&type=template&id=033837ac&scoped=true&"
import script from "./TheEditor.vue?vue&type=script&lang=js&"
export * from "./TheEditor.vue?vue&type=script&lang=js&"
import style0 from "./TheEditor.vue?vue&type=style&index=0&id=033837ac&lang=scss&scoped=true&"
import style1 from "./TheEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033837ac",
  null
  
)

export default component.exports